import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';



//Custom Components

import MainPage from '../pages/main';
import About from '../pages/about';
import Services from '../pages/service';
import ServiceOne from '../pages/service/service-1';
import ServiceTwo from '../pages/service/service-2';
import ServiceDetails from '../pages/service/service-details';
import SoftwareDevelopment from '../pages/service/software-development';
import WebDevelopment from '../pages/service/web-development';
import AnalyticSolutions from '../pages/service/analytic-solutions';
import CloudAndDevops from '../pages/service/cloud-and-devops';
import SystemIntegration from '../pages/service/system-integration';
import RecruitingStaffing from '../pages/service/recruiting-staffing';
import ProjectDesign from '../pages/service/project-design';
import DataCenter from '../pages/service/data-center';
import MarketAnalysis from '../pages/service/market-analysis';
import BusinessStrategy from '../pages/service/business-strategy';
import MarketEntry from '../pages/service/market-entry';
import PartnershipsAlliances from '../pages/service/partnerships-alliances';
import SalesMarketing from '../pages/service/sales-marketing';
import ProductDevelopment from '../pages/service/product-development';
import BusinessDevelopment from '../pages/service/business-development';
import ITSoftware from '../pages/service/it-software';
import PastPerformance from '../pages/past-performance';
import Contact from '../pages/contact';
import Error from '../pages/404';
import LoadTop from '../components/Common/ScrollTop/LoadTop'


const App = () => {
    useEffect(() => {
        const el = document.querySelector(".loader-container");
        if (el) {
            el.remove();
        }
    }, []);

    return (
        <div className='App'>
            <LoadTop />
            <Switch>
                <Route path="/" exact component={MainPage} />
                <Route path="/home" component={MainPage} />
                <Route path="/about" component={About} />
                <Route path="/service" exact component={Services} />
                <Route path="/service/service-1" component={ServiceOne} />
                <Route path="/service/service-2" component={ServiceTwo} />
                <Route path="/service/service-details" component={ServiceDetails} />
                <Route path="/service/software-development" component={SoftwareDevelopment} />
                <Route path="/service/system-integration" component={SystemIntegration} />
                <Route path="/service/recruiting-staffing" component={RecruitingStaffing} />
                <Route path="/service/web-development" component={WebDevelopment} />
                <Route path="/service/analytic-solutions" component={AnalyticSolutions} />
                <Route path="/service/cloud-and-devops" component={CloudAndDevops} />
                <Route path="/service/project-design" component={ProjectDesign} />
                <Route path="/service/data-center" component={DataCenter} />
                <Route path="/service/market-analysis" component={MarketAnalysis} />
                <Route path="/service/business-development" component={BusinessDevelopment} />
                <Route path="/service/it-software" component={ITSoftware} />
                <Route path="/past-performance" component={PastPerformance} />
                <Route path="/service/business-strategy" component={BusinessStrategy} />
                <Route path="/service/market-entry" component={MarketEntry} />
                <Route path="/service/partnerships-alliances" component={PartnershipsAlliances} />
                <Route path="/service/sales-marketing" component={SalesMarketing} />
                <Route path="/service/product-development" component={ProductDevelopment} />
                <Route path="/contact" component={Contact} />
                <Route component={Error} />
            </Switch>
        </div>
    );
}

export default App;
